import { CellSubType, CellType } from "utils/enums";
import { IProductTemplateTableEditor } from "components/ComponentTypeTypes";
import { DatasetLoadingConf } from "../charts/interfaces";
import { IProductTemplateTableProps } from "../product-template-table/utils/interfaces";

export interface ITiledProductItemViewEditor extends IProductTemplateTableEditor {
  valueColumn?: string;
  setpointColumn?: string;
  conditionColumn?: string;
  columnsToDisplayInTooltip?: string[];
  loadConf?: DatasetLoadingConf;
  decimalPlaces?: number;
  useConditionForValidation?: boolean;
  defaultColor?: string;
}

export type ITiledProductItemView = IProductTemplateTableProps & ITiledProductItemViewEditor;

export const allowedTypes = [CellType.DATASET, CellType.MULTI_VALUE];
export const allowedSubtypes = [CellSubType.DATASET];

export interface AggregatedValue {
  id: string;
  value: string;
}

export const expiredGradient = `repeating-linear-gradient(
      45deg,
      white,
      white 2px,
      black 2px,
      black 5px
    )`;

export const defaultBgColor = "#f3f5f6";
